import {createSlice } from '@reduxjs/toolkit'

const AddArticleInAPISlice = createSlice({
    name: "AddArticleInAPISlice",
    initialState: {
        AddedArticleAPI:{
                id: '',
                Name: '',
                OtherExpenditure: false,
                TransactionType: false,
                Type: false,
            },
        EditAddedArticleAPI: false        
    },
    reducers: {
        setEditAddedArticleAPI(state, actions){
            state.EditAddedArticleAPI = actions.payload.EditCheck

            state.AddedArticleAPI = {
                id: actions.payload.id,
                Name: actions.payload.Name,
                OtherExpenditure: actions.payload.OtherExpenditure,
                TransactionType: actions.payload.TransactionType,
                Type: actions.payload.Type  
            }
        },
        changeValueAddedArticleAPI(state, actions){
            switch(actions.payload.Type){
                case('Name'):{
                    state.AddedArticleAPI.Name = actions.payload.Value
                    break
                }
                case('OtherExpenditure'):{
                    state.AddedArticleAPI.OtherExpenditure = actions.payload.Value
                    break
                }
                case('isRevenue'):{
                    state.AddedArticleAPI.isRevenue = actions.payload.Value
                    break
                }
                case('TransactionType'):{
                    state.AddedArticleAPI.TransactionType = actions.payload.Value
                    break
                }
                case('Type'):{
                    state.AddedArticleAPI.Type = actions.payload.Value
                    break
                }              
                default:{
                    break
                }
            }            
        },
        clearAddedArticleAPI(state){
            state.AddedArticleAPI = {
                id: '',
                Name: '',
                OtherExpenditure: false,
                TransactionType: false,
                Type: false,
            }
        state.EditAddedArticleAPI = false 
        }
    }
})

export default AddArticleInAPISlice.reducer
export const { setEditAddedArticleAPI, changeValueAddedArticleAPI, clearAddedArticleAPI } = AddArticleInAPISlice.actions